// @flow
import { ActionHelper } from 'modules/helper';

const actionTypePrefix = 'Careers/';
export const CareerActionTypes = {
  CAREERS: ActionHelper.createActionTypes(actionTypePrefix, 'CAREERS'),
  SPECIFICJOB: ActionHelper.createActionTypes(actionTypePrefix, 'SPECIFICJOB'),
};
